import { Reducer } from 'redux';
import { SellingSettingsInterface, SellingTerminalsState, SellingTerminalsTypes } from './types';

const INITIAL_SELLING_SETTINGS: SellingSettingsInterface = {
  tokenSellingOnline: false,
  sellingOnlineDefault: false,
  freeBenefitId: null,
  requisitionBenefitId: null,
  voucherBenefitId: null,
  payerBenefitId: null,
  sellingExpirationSeconds: 3600,
  onlineExpirationSeconds: 86400,
  offlineExpirationSeconds: 300,
  hasCommonProfileCheck: false,
  defaultLineStopId: null,
  tokensLimit: 10,
};

const INITIAL_STATE: SellingTerminalsState = {
  sellingTerminalData: {
    id: '',
    fee: 0,
    status: 0,
    type: 0,
    allowedAmount: 0,
    name: '',
    document: '',
    email: '',
    phone: '',
    startPeriod: '',
    endPeriod: '',
    SellingPoints: [],
    SellingTerminalPayments: [],
    Addresses: [],
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
  },
  sellingTerminalsResume: {
    totalPending: 0,
    totalCollected: 0,
    totalPaid: 0,
    totalTicketCount: 0,
    totalPurchaseCount: 0,
  },
  sellingTerminalsList: [],
  sellingTerminalsDailyReports: [],
  sellingTerminalsResumeList: [],
  sellingReportsResume: {
    totalPending: 0,
    totalCollected: 0,
    totalPaid: 0,
    totalTicketCount: 0,
    totalPurchaseCount: 0,
  },
  paymentsList: [],
  sellingTerminalWalletHistories: [],
  sellingTerminalWalletBalances: [],
  apiTokenBalance: {
    subscription: {
      amount: 0,
      consumed: 0,
      available: 0,
    },
    extras: {
      amount: 0,
      consumed: 0,
      available: 0,
    },
    total: 0,
    used: 0,
    available: 0,
    overage: 0,
  },
  apiTokenPackagePurchase: null,
  apiTokenEnroll: null,
  apiTokenPackageList: [],
  apiTokenSubscription: {
    alreadyPaid: false,
    balance: null,
    subscription: null,
    pendingCharge: null,
    contractStatus: null,
    setupFee: null,
    packageList: [],
  },
  apiTokenDisable: null,
  transactionsList: [],
  sellingTerminalCashierList: [],
  selectedReceivingType: undefined,
  sellingShiftList: [],
  ticketCountList: [],
  shiftScheduleList: [],
  sellingSettingsData: INITIAL_SELLING_SETTINGS,
  sellingTerminalPaymentRequestsList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<SellingTerminalsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LIST SELLING TERMINALS
    case SellingTerminalsTypes.LIST_SELLING_TERMINALS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalsList: INITIAL_STATE.sellingTerminalsList,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        sellingTerminalsList: action.payload.sellingTerminalsList,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalsList: INITIAL_STATE.sellingTerminalsList,
      };

    // CASES LIST SELLING TERMINAL CASHIER REQUEST
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_CASHIER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalCashierList: INITIAL_STATE.sellingTerminalCashierList,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_CASHIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalCashierList: action.payload.sellingTerminalCashierList,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_CASHIER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalCashierList: INITIAL_STATE.sellingTerminalCashierList,
      };
    // CASES GET SELLING TERMINAL
    case SellingTerminalsTypes.GET_SELLING_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalData: INITIAL_STATE.sellingTerminalData,
      };
    case SellingTerminalsTypes.GET_SELLING_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalData: action.payload.sellingTerminalData,
      };
    case SellingTerminalsTypes.GET_SELLING_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalData: INITIAL_STATE.sellingTerminalData,
      };
    // CASES GET DAILY SELLING TERMINAL
    case SellingTerminalsTypes.GET_DAILY_SELLING_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalsDailyReports:
          INITIAL_STATE.sellingTerminalsDailyReports,
      };
    case SellingTerminalsTypes.GET_DAILY_SELLING_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalsDailyReports:
          action.payload.sellingTerminalsDailyReports,
      };
    case SellingTerminalsTypes.GET_DAILY_SELLING_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalsDailyReports:
          INITIAL_STATE.sellingTerminalsDailyReports,
      };
    // CASES FILTER SELLING TERMINALS
    case SellingTerminalsTypes.FILTER_SELLING_TERMINALS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalsList: INITIAL_STATE.sellingTerminalsList,
      };
    case SellingTerminalsTypes.FILTER_SELLING_TERMINALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        sellingTerminalsList: action.payload.sellingTerminalsList,
      };
    case SellingTerminalsTypes.FILTER_SELLING_TERMINALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalsList: INITIAL_STATE.sellingTerminalsList,
      };
    // CASES CREATE SELLING TERMINAL
    case SellingTerminalsTypes.CREATE_SELLING_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalData: INITIAL_STATE.sellingTerminalData,
      };
    case SellingTerminalsTypes.CREATE_SELLING_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalData: action.payload.sellingTerminalData,
      };
    case SellingTerminalsTypes.CREATE_SELLING_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalData: INITIAL_STATE.sellingTerminalData,
      };
    // CASES UPDATE SELLING TERMINAL
    case SellingTerminalsTypes.UPDATE_SELLING_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_SELLING_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalData: action.payload.sellingTerminalData,
      };
    case SellingTerminalsTypes.UPDATE_SELLING_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES DELETE SELLING TERMINAL
    case SellingTerminalsTypes.DELETE_SELLING_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.DELETE_SELLING_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.DELETE_SELLING_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES ADD PAYMENT SELLING TERMINAL
    case SellingTerminalsTypes.ADD_PAYMENT_SELLING_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.ADD_PAYMENT_SELLING_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.ADD_PAYMENT_SELLING_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES ADD PRE PAID PAYMENT SELLING TERMINAL
    case SellingTerminalsTypes.ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES CHANGE SELLING TERMINAL STATUS
    case SellingTerminalsTypes.CHANGE_SELLING_TERMINAL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.CHANGE_SELLING_TERMINAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.CHANGE_SELLING_TERMINAL_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES LIST PAYMENTS
    case SellingTerminalsTypes.LIST_PAYMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        paymentsList: INITIAL_STATE.paymentsList,
      };
    case SellingTerminalsTypes.LIST_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paymentsList: action.payload.paymentsList,
      };
    case SellingTerminalsTypes.LIST_PAYMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paymentsList: INITIAL_STATE.paymentsList,
      };
    // CASES LIST SELLING TERMINAL WALLET HISTORIES
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_HISTORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalWalletHistories:
          INITIAL_STATE.sellingTerminalWalletHistories,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_HISTORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalWalletHistories:
          action.payload.sellingTerminalWalletHistories,
        totalCount: action.payload.totalCount,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_HISTORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalWalletHistories:
          INITIAL_STATE.sellingTerminalWalletHistories,
      };
    // CASES LIST SELLING TERMINAL WALLET BALANCES
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_BALANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalWalletBalances:
          INITIAL_STATE.sellingTerminalWalletBalances,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_BALANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalWalletBalances:
          action.payload.sellingTerminalWalletBalances,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_WALLET_BALANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalWalletBalances:
          INITIAL_STATE.sellingTerminalWalletBalances,
      };
    // CASES API TOKEN PACKAGE PURCHASE
    case SellingTerminalsTypes.API_TOKEN_PACKAGE_PURCHASE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        apiTokenPackagePurchase: INITIAL_STATE.apiTokenPackagePurchase,
      };
    case SellingTerminalsTypes.API_TOKEN_PACKAGE_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        apiTokenPackagePurchase: action.payload.apiTokenPackagePurchase,
      };
    case SellingTerminalsTypes.API_TOKEN_PACKAGE_PURCHASE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        apiTokenPackagePurchase: INITIAL_STATE.apiTokenPackagePurchase,
      };

    // CASES API TOKEN BALANCE
    case SellingTerminalsTypes.API_TOKEN_BALANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        apiTokenBalance: INITIAL_STATE.apiTokenBalance,
      };
    case SellingTerminalsTypes.API_TOKEN_BALANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        apiTokenBalance: action.payload.apiTokenBalance,
      };
    case SellingTerminalsTypes.API_TOKEN_BALANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        apiTokenBalance: INITIAL_STATE.apiTokenBalance,
      };
    // CASES API TOKEN ENROLL
    case SellingTerminalsTypes.API_TOKEN_ENROLL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        apiTokenEnroll: INITIAL_STATE.apiTokenEnroll,
      };
    case SellingTerminalsTypes.API_TOKEN_ENROLL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        apiTokenEnroll: action.payload.apiTokenEnroll,
      };
    case SellingTerminalsTypes.API_TOKEN_ENROLL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        apiTokenEnroll: INITIAL_STATE.apiTokenEnroll,
      };

    // CASES API TOKEN SUBSCRIPTION
    case SellingTerminalsTypes.API_TOKEN_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        apiTokenSubscription: INITIAL_STATE.apiTokenSubscription,
      };
    case SellingTerminalsTypes.API_TOKEN_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        apiTokenSubscription: action.payload.apiTokenSubscription,
      };
    case SellingTerminalsTypes.API_TOKEN_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        apiTokenSubscription: INITIAL_STATE.apiTokenSubscription,
      };
    // CASES API TOKEN PACKAGE LIST
    case SellingTerminalsTypes.API_TOKEN_PACKAGE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        apiTokenPackageList: INITIAL_STATE.apiTokenPackageList,
      };
    case SellingTerminalsTypes.API_TOKEN_PACKAGE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        apiTokenPackageList: action.payload.apiTokenPackageList,
      };
    case SellingTerminalsTypes.API_TOKEN_PACKAGE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        apiTokenPackageList: INITIAL_STATE.apiTokenPackageList,
      };
    // CASES API TOKEN DISABLE
    case SellingTerminalsTypes.API_TOKEN_DISABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        apiTokenDisable: INITIAL_STATE.apiTokenDisable,
      };
    case SellingTerminalsTypes.API_TOKEN_DISABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        apiTokenDisable: action.payload.apiTokenDisable,
      };
    case SellingTerminalsTypes.API_TOKEN_DISABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        apiTokenDisable: INITIAL_STATE.apiTokenDisable,
      };
    // CASES API TOKEN SUBSCRIPTION AUTO CHARGE
    case SellingTerminalsTypes.API_TOKEN_SUBSCRIPTION_AUTO_CHARGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.API_TOKEN_SUBSCRIPTION_AUTO_CHARGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.API_TOKEN_SUBSCRIPTION_AUTO_CHARGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES LIST TRANSACTIONS
    case SellingTerminalsTypes.LIST_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transactionsList: INITIAL_STATE.transactionsList,
      };
    case SellingTerminalsTypes.LIST_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transactionsList: action.payload.transactionsList,
      };
    case SellingTerminalsTypes.LIST_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transactionsList: INITIAL_STATE.transactionsList,
      };

    // CASES SELLING TERMINALS RESUME
    case SellingTerminalsTypes.GET_SELLING_TERMINALS_RESUME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalsResume: INITIAL_STATE.sellingTerminalsResume,
      };
    case SellingTerminalsTypes.GET_SELLING_TERMINALS_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalsResume: action.payload.sellingTerminalsResume,
      };
    case SellingTerminalsTypes.GET_SELLING_TERMINALS_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalsResume: INITIAL_STATE.sellingTerminalsResume,
      };

    // CASES SELLING REPORTS RESUME
    case SellingTerminalsTypes.GET_SELLING_REPORTS_RESUME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingReportsResume: INITIAL_STATE.sellingReportsResume,
      };
    case SellingTerminalsTypes.GET_SELLING_REPORTS_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingReportsResume: action.payload.sellingReportsResume,
      };
    case SellingTerminalsTypes.GET_SELLING_REPORTS_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingReportsResume: INITIAL_STATE.sellingReportsResume,
      };

    // CASES SELLING TERMINALS RESUME LIST
    case SellingTerminalsTypes.LIST_TRANSACTIONS_RESUME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalsResumeList: INITIAL_STATE.sellingTerminalsResumeList,
      };
    case SellingTerminalsTypes.LIST_TRANSACTIONS_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalsResumeList: action.payload.sellingTerminalsResumeList,
      };
    case SellingTerminalsTypes.LIST_TRANSACTIONS_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalsResumeList: INITIAL_STATE.sellingTerminalsResumeList,
      };

    // SET SELECTED CREDIT TYPE
    case SellingTerminalsTypes.SET_SELECTED_RECEIVING_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        selectedReceivingType: action.payload.selectedReceivingType,
      };

    // CASES SELLING TERMINALS PAY BOLETO
    case SellingTerminalsTypes.SELLING_TERMINALS_PAY_BOLETO_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.SELLING_TERMINALS_PAY_BOLETO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.SELLING_TERMINALS_PAY_BOLETO_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // CASES LIST SELLING SHIFT
    case SellingTerminalsTypes.LIST_SELLING_SHIFT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingShiftList: INITIAL_STATE.sellingShiftList,
      };
    case SellingTerminalsTypes.LIST_SELLING_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        sellingShiftList: action.payload.sellingShiftList,
      };
    case SellingTerminalsTypes.LIST_SELLING_SHIFT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingShiftList: INITIAL_STATE.sellingShiftList,
      };
    
    // CASES UPDATE API TOKEN CONTRACT
    case SellingTerminalsTypes.UPDATE_API_TOKEN_CONTRACT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_API_TOKEN_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_API_TOKEN_CONTRACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES LIST TICKET COUNT SUCCESS
    case SellingTerminalsTypes.LIST_TICKET_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ticketCountList: INITIAL_STATE.ticketCountList,
      };
    case SellingTerminalsTypes.LIST_TICKET_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ticketCountList: action.payload.ticketCountList,
      };
    case SellingTerminalsTypes.LIST_TICKET_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        ticketCountList: INITIAL_STATE.ticketCountList,
      };

    // CASES CREATE TICKET COUNT SUCCESS
    case SellingTerminalsTypes.CREATE_TICKET_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.CREATE_TICKET_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.CREATE_TICKET_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES UPDATE TICKET COUNT SUCCESS
    case SellingTerminalsTypes.UPDATE_TICKET_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_TICKET_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_TICKET_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES DELETE TICKET COUNT SUCCESS
    case SellingTerminalsTypes.DELETE_TICKET_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.DELETE_TICKET_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.DELETE_TICKET_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES LIST SHIFT SCHEDULE SUCCESS
    case SellingTerminalsTypes.LIST_SHIFT_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        shiftScheduleList: INITIAL_STATE.shiftScheduleList,
      };
    case SellingTerminalsTypes.LIST_SHIFT_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        shiftScheduleList: action.payload.shiftScheduleList,
      };
    case SellingTerminalsTypes.LIST_SHIFT_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        shiftScheduleList: INITIAL_STATE.shiftScheduleList,
      };

    // CASES CREATE SHIFT SCHEDULE SUCCESS
    case SellingTerminalsTypes.CREATE_SHIFT_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.CREATE_SHIFT_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.CREATE_SHIFT_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES UPDATE SHIFT SCHEDULE SUCCESS
    case SellingTerminalsTypes.UPDATE_SHIFT_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_SHIFT_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_SHIFT_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES DELETE SHIFT SCHEDULE SUCCESS
    case SellingTerminalsTypes.DELETE_SHIFT_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.DELETE_SHIFT_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.DELETE_SHIFT_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES SHIFT SCHEDULE RUN REQUESTS
    case SellingTerminalsTypes.SHIFT_SCHEDULE_RUN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.SHIFT_SCHEDULE_RUN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.SHIFT_SCHEDULE_RUN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES SELLING SETTINGS
    case SellingTerminalsTypes.GET_SELLING_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.GET_SELLING_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingSettingsData: action.payload.sellingSettingsData,
      };
    case SellingTerminalsTypes.GET_SELLING_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingSettingsData: INITIAL_SELLING_SETTINGS,
      };
    case SellingTerminalsTypes.UPDATE_SELLING_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.UPDATE_SELLING_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingSettingsData: action.payload.sellingSettingsData,
      };
    case SellingTerminalsTypes.UPDATE_SELLING_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES LIST SELLING TERMINAL PAYMENT REQUESTS
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_PAYMENT_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        sellingTerminalPaymentRequestsList:
          INITIAL_STATE.sellingTerminalPaymentRequestsList,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_PAYMENT_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        sellingTerminalPaymentRequestsList:
          action.payload.sellingTerminalPaymentRequestsList,
      };
    case SellingTerminalsTypes.LIST_SELLING_TERMINAL_PAYMENT_REQUESTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        sellingTerminalPaymentRequestsList:
          INITIAL_STATE.sellingTerminalPaymentRequestsList,
      };

    // CASES CANCEL SELLING TERMINAL PAYMENT REQUEST
    case SellingTerminalsTypes.CANCEL_SELLING_TERMINAL_PAYMENT_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SellingTerminalsTypes.CANCEL_SELLING_TERMINAL_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SellingTerminalsTypes.CANCEL_SELLING_TERMINAL_PAYMENT_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
